import axios from 'axios'
import { getCursorUrl, goAuthLogin, getStorageToken,setSessionStorage,getBeMySelfUrl,getTppTokenKey } from '@/utils/tools'
// import { Dialog } from 'vant'

const isDev = process.env.NODE_ENV === 'development';
axios.defaults.withCredentials = true;
axios.defaults.crossDomain = true;
// axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded; charset=utf-8';

const service = axios.create({
  timeout: 60000, // 请求超时时间
  async: true,
  crossDomain: true
})

service.interceptors.request.use(
  config => { 
    
    config.baseURL= isDev ? (config.domain==='open.xjy.cn'?getBeMySelfUrl():'') :(config.domain==='open.xjy.cn'?getBeMySelfUrl():getCursorUrl());
    // // 设置json格式
    // config.headers['Content-Type'] = 'application/json';
    // config.headers['Content-Type'] = 'application/x-www-form-urlencoded';

    let inWhiteList = [
      '/admin/Webapi/wxconfig',
      '/admin/Xplan/xplandetail',
      '/admin/Xplan/gettitle',
      '/admin/Xplan/ability',
      '/admin/Xplan/abilitycommit',
      '/admin/Xplan/reprot',
      '/admin/Xplan/index',
      '/admin/Xplan/answer',
      '/admin/ceping49/index',
      '/admin/ceping49/answer',
      '/admin/ceping49/ta_answer',
      '/admin/ceping49/ta_index',
      '/admin/ceping49/report',
      '/admin/ceping52/report',
      '/admin/ceping52/reset',
      '/admin/ceping52/ta_answer',
      '/admin/ceping52/ta_index',
      '/admin/ceping52/index',
      '/admin/ceping52/answer',
      '/admin/ceping47/report',
      '/admin/ceping47/index',
      '/admin/ceping47/answer',
      '/admin/ceping51/report',
      '/admin/Worth/report',
      '/admin/Worth/index',
      '/admin/Worth/answer',
      '/admin/ceping51/index',
      '/admin/ceping51/answer',
      '/admin/ceping54/report',
      '/admin/ceping54/index',
      '/admin/ceping54/answer',
      '/admin/ceping54/reset',
      '/admin/ceping56/index',
      '/admin/ceping56/answer',
      '/admin/ceping56/reset',
      '/admin/ceping56/report',
      '/admin/ceping57/index',
      '/admin/ceping57/answer',
      '/admin/ceping57/reset',
      '/admin/ceping57/report',
      '/admin/ceping55/detail',
      '/admin/ceping55/index',
      '/admin/ceping55/answer',
      '/admin/ceping55/reset',
      '/admin/ceping55/report',
      '/admin/ceping59/index',
      '/admin/ceping59/answer',
      '/admin/ceping59/ta_answer',
      '/admin/ceping59/ta_index',
      '/admin/ceping59/reset',
      '/admin/ceping59/report',
      '/admin/ceping61/index',
      '/admin/ceping61/answer',
      '/admin/ceping61/reset',
      '/admin/ceping61/report',
      '/admin/ceping62/detail',
      '/admin/ceping62/index',
      '/admin/ceping62/answer',
      '/admin/ceping62/reset',
      '/admin/ceping62/report',
      '/api/Evaluation/list',
      '/api/evaluation/index',
      '/api/evaluation/answer',
      '/api/evaluation/reset',
      '/api/evaluation/report',
      '/admin/ceping63/index',
      '/admin/ceping63/answer',
      '/admin/ceping63/reset',
      '/admin/ceping63/report',
      '/admin/ceping64/index',
      '/admin/ceping64/answer',
      '/admin/ceping64/reset',
      '/admin/ceping64/report',
      '/api/pdfbuild/sendPdf',
      '/admin/ceping65/index',
      '/admin/ceping65/answer',
      '/admin/ceping65/ta_answer',
      '/admin/ceping65/ta_index',
      '/admin/ceping65/reset',
      '/admin/ceping65/report',
      '/admin/ceping67/index',
      '/admin/ceping67/section',
      '/admin/ceping67/answer',
      '/admin/ceping67/reset',
      '/admin/ceping67/report',
      '/api/debug/report',
      '/admin/ceping/getData',
      '/admin/ceping/saveData',
      '/admin/ceping68/index',
      '/admin/ceping68/answer',
      '/admin/ceping68/report',
      '/admin/ceping68/reset',
      '/admin/xuandui65/index',
      '/admin/xuandui65/answer',
      '/admin/xuandui65/ta_answer',
      '/admin/xuandui65/ta_index',
      '/admin/xuandui65/reset',
      '/admin/xuandui65/report',
      '/admin/test65/index',
      '/admin/test65/answer',
      '/admin/test65/ta_answer',
      '/admin/test65/ta_index',
      '/admin/test65/reset',
      '/admin/test65/report',
      '/admin/acca65/index',
      '/admin/acca65/answer',
      '/admin/acca65/ta_answer',
      '/admin/acca65/ta_index',
      '/admin/acca65/reset',
      '/admin/acca65/report',
      '/admin/acca65/save_info',
      '/admin/acca65/get_info',
      '/admin/ceping69/index',
      '/admin/ceping69/answer',
      '/admin/ceping69/ta_answer',
      '/admin/ceping69/ta_index',
      '/admin/ceping69/reset',
      '/admin/ceping69/report',
      '/admin/ceping70/index',
      '/admin/ceping70/answer',
      '/admin/ceping70/ta_answer',
      '/admin/ceping70/ta_index',
      '/admin/ceping70/reset',
      '/admin/ceping70/report',
      '/admin/ceping70/detail',
      '/admin/bd_ceping64/index',
      '/admin/bd_ceping64/answer',
      '/admin/bd_ceping64/reset',
      '/admin/bd_ceping64/report',
      '/admin/bd_ceping65/index',
      '/admin/bd_ceping65/answer',
      '/admin/bd_ceping65/ta_answer',
      '/admin/bd_ceping65/ta_index',
      '/admin/bd_ceping65/reset',
      '/admin/bd_ceping65/report',
      '/admin/bd_ceping67/index',
      '/admin/bd_ceping67/section',
      '/admin/bd_ceping67/answer',
      '/admin/bd_ceping67/reset',
      '/admin/bd_ceping67/report',
      '/admin/ceping71/index',
      '/admin/ceping71/answer',
      '/admin/ceping71/reset',
      '/admin/ceping71/report',
      '/admin/ceping71/detail',
      '/admin/ceping96/index',
      '/admin/ceping96/answer',
      '/admin/ceping96/reset',
      '/admin/ceping96/report',
      '/admin/ceping96/detail',
      '/admin/ceping72/index',
      '/admin/ceping72/answer',
      '/admin/ceping72/reset',
      '/admin/ceping72/report',
      '/admin/ceping72/save_extra',
      '/admin/ceping/source',
      '/admin/ceping72/evaluation',
      '/admin/ceping/ad',
      '/admin/ceping/get_extra_info',
      '/admin/ceping73/index',
      '/admin/ceping73/answer',
      '/admin/ceping73/reset',
      '/admin/ceping73/report',
      '/admin/ceping73/save_extra',
      '/admin/ceping73/detail',
      '/admin/ceping47/detail',
      '/admin/ceping49/detail',
      '/admin/ceping52/detail',
      '/admin/ceping54/detail',
      '/admin/ceping74/report',
      '/admin/ceping74/index',
      '/admin/ceping74/answer',
      '/admin/ceping74/reset',
      '/admin/ceping74/detail',
      '/admin/ceping75/index',
      '/admin/ceping75/answer',
      '/admin/ceping75/reset',
      '/admin/ceping75/report',
      '/admin/bd_ceping69/index',
      '/admin/bd_ceping69/answer',
      '/admin/bd_ceping69/reset',
      '/admin/bd_ceping69/report',
      '/admin/ceping76/report',
      '/admin/ceping76/reset',
      '/admin/ceping76/ta_answer',
      '/admin/ceping76/ta_index',
      '/admin/ceping76/index',
      '/admin/ceping76/answer',
      '/admin/ceping76/ta_send_word',
      '/admin/ceping76/get_ta_word',
      '/admin/ceping76/detail',
      '/admin/ceping44/extra',
      '/admin/ceping44/save_extra',
      '/admin/sale_ceping71/index',
      '/admin/sale_ceping71/answer',
      '/admin/sale_ceping71/report',
      '/admin/test71/index',
      '/admin/test71/answer',
      '/admin/test71/report',
      '/admin/test52/report',
      '/admin/test52/reset',
      '/admin/test52/ta_answer',
      '/admin/test52/ta_index',
      '/admin/test52/index',
      '/admin/test52/answer',
      '/admin/test52/detail',
      '/admin/test73/index',
      '/admin/test73/answer',
      '/admin/test73/reset',
      '/admin/test73/report',
      '/admin/test73/save_extra',
      '/admin/test73/detail',
      '/admin/ceping78/index',
      '/admin/ceping78/answer',
      '/admin/ceping78/reset',
      '/admin/ceping78/report',
      '/admin/ceping78/save_extra',
      '/admin/ceping78/detail',
      '/admin/ceping84/index',
      '/admin/ceping84/answer',
      '/admin/ceping84/reset',
      '/admin/ceping84/report',
      '/admin/ceping84/save_extra',
      '/admin/ceping84/detail',
      '/admin/ceping97/index',
      '/admin/ceping97/answer',
      '/admin/ceping97/reset',
      '/admin/ceping97/report',
      '/admin/ceping97/save_extra',
      '/admin/ceping97/detail',
      '/admin/ceping85/index',
      '/admin/ceping85/answer',
      '/admin/ceping85/reset',
      '/admin/ceping85/report',
      '/admin/ceping85/save_extra',
      '/admin/ceping85/detail',
      '/admin/ceping86/index',
      '/admin/ceping86/answer',
      '/admin/ceping86/reset',
      '/admin/ceping86/report',
      '/admin/ceping86/save_extra',
      '/admin/ceping86/detail',
      '/admin/ceping87/index',
      '/admin/ceping87/answer',
      '/admin/ceping87/reset',
      '/admin/ceping87/report',
      '/admin/ceping87/save_extra',
      '/admin/ceping87/detail',
      '/admin/ceping88/index',
      '/admin/ceping88/answer',
      '/admin/ceping88/reset',
      '/admin/ceping88/report',
      '/admin/ceping88/save_extra',
      '/admin/ceping88/detail',
      '/admin/ceping89/index',
      '/admin/ceping89/answer',
      '/admin/ceping89/reset',
      '/admin/ceping89/report',
      '/admin/ceping89/save_extra',
      '/admin/ceping89/detail',
      '/admin/ceping90/index',
      '/admin/ceping90/answer',
      '/admin/ceping90/reset',
      '/admin/ceping90/report',
      '/admin/ceping90/save_extra',
      '/admin/ceping90/detail',
      '/admin/ceping91/index',
      '/admin/ceping91/answer',
      '/admin/ceping91/reset',
      '/admin/ceping91/report',
      '/admin/ceping91/save_extra',
      '/admin/ceping91/detail',
      '/admin/ceping92/index',
      '/admin/ceping92/answer',
      '/admin/ceping92/reset',
      '/admin/ceping92/report',
      '/admin/ceping92/save_extra',
      '/admin/ceping92/detail',
      '/admin/ceping93/index',
      '/admin/ceping93/answer',
      '/admin/ceping93/reset',
      '/admin/ceping93/report',
      '/admin/ceping93/save_extra',
      '/admin/ceping93/detail',
      '/admin/ceping94/index',
      '/admin/ceping94/answer',
      '/admin/ceping94/reset',
      '/admin/ceping94/report',
      '/admin/ceping94/save_extra',
      '/admin/ceping94/detail',
      '/admin/ceping79/index',
      '/admin/ceping79/answer',
      '/admin/ceping79/reset',
      '/admin/ceping79/report',
      '/admin/ceping79/detail',
      '/admin/ceping79/support_user',
      '/admin/ceping79/check_support_user',
      '/admin/sale_ceping73/index',
      '/admin/sale_ceping73/answer',
      '/admin/sale_ceping73/report',
      '/admin/sale_ceping73/save_extra',
      '/admin/sale_ceping73/detail',
      '/admin/ceping46/index',
      '/admin/ceping46/answer',
      '/admin/ceping46/reset',
      '/admin/ceping46/report',
      '/admin/ceping46/save_extra',
      '/admin/ceping46/detail',
      '/admin/ceping80/info',
      '/admin/ceping80/poster',
      '/admin/ceping80/invite_log',
      '/admin/ceping80/activity_log',
      '/admin/ceping80/log_activity',
      '/admin/ceping80/support_user',
      '/admin/ceping80/reset',
      '/admin/ceping81/info',
      '/admin/ceping81/poster',
      '/admin/ceping81/support_user',
      '/admin/ceping81/rank_list',
      '/admin/ceping81/reset',
      '/admin/ceping/event',
      '/admin/activity/rank_list',
      '/admin/activity/support_user',
      '/admin/ceping58/save_extra',
      '/admin/ceping58/detail',
      '/admin/ceping58/index',
      '/admin/ceping58/report',
      '/admin/ceping/save_data',
      '/admin/ceping82/save_extra',
      '/admin/ceping/get_data',
      '/admin/ceping/get_data_list',
      '/admin/ceping82/info',
      '/admin/ceping82/poster',
      '/admin/ceping83/index',
      '/admin/ceping83/answer',
      '/admin/ceping83/reset',
      '/admin/ceping83/report',
      '/admin/ceping83/detail',
      '/admin/ceping/submit_mantis',
      '/admin/ceping95/index',
      '/admin/ceping95/section',
      '/admin/ceping95/answer',
      '/admin/ceping95/reset',
      '/admin/ceping95/report',
      '/admin/ceping/progress',
      '/admin/send_sms',
      '/admin/check_sms',
    ].includes(config.url);

    if(isDev && config.domain!='open.xjy.cn'){
      config.url = '/api' + config.url;
    }

    // token
    let token = getStorageToken();
    let tpp_token_key = getTppTokenKey();

    if(token.length != 32 && !inWhiteList) {
      window.localStorage[tpp_token_key] = '';
      goAuthLogin('请求不在白名单');
      return Promise.reject('重新登录');
    }

    if(token){
      // 在header参数里面加入token
      config.data['token'] = token;
    }

    return config;
  },
  err => {
    return Promise.reject(err);
  }
);

service.interceptors.response.use(
    response => {
      // 这里后端接口好不专业，登陆过期居然给我一个字符串状态码
      let code = response.data.code;
      let isSuccess = code == "10001";
      let isNo = code == "10002";
      let iserrer_ = response.data.error >0;
      let isOverdue = code == "10003";
      let isLogout = response.data.msg === "微信登录过期" ||  response.data.msg === "需要登录";
      let isLogout2 = response.data.msg === "需要登录";
      let isNotBuy = response.data.msg == "课程未购买";

      // 成功
      if(isSuccess){
        // 判断是否有bid,如果存在，就存session Storage，用户header判断
        if(response.data.data.bid && response.data.data.bid!=''){
          setSessionStorage('request','/bid',response.data.data.bid)
        }
        return response.data.data
      }else if(isNo || iserrer_){
        return response.data
      }

      // 登录过期
      if(isOverdue && isLogout || isLogout2){
        // 跳转微信登录
        // goAuthLogin(response.config.url + '接口失效' + response.config.data);
        window.observer.publish('login', response.config.url + '接口失效' + response.config.data, true, true);
        return
      }else if(isOverdue && isNotBuy) {
        location.href = response.data.data;
      }
      return response.data.data?response.data.data:(response.data?response.data:response)

    },
    error => {

      // let code = error.response.code;

      // if(code === 500){
        // Dialog.alert({
        //   title: '网络错误',
        //   message: '网络错误，请检查您的网络！'
        // }).then(() => {});
      // }

      return Promise.reject(error)
    }
);

export default service
